import { useState, useEffect } from 'react';
import { Form, Button, Checkbox, Flex, Typography, ConfigProvider } from 'antd';
import { CustomFormInput } from '../../../components';
import LoginFormLayout from '../../../components/LoginFormLayout/LoginFormLayout';
import CreateNewPassword from '../CreateNewPasswordForm/CreateNewPassword';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

const { Text } = Typography;

const RegistrationForm = ({ onHandleRegistration }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [loading, setLoading] = useState(false);
  const [role, setRole] = useState(null);
  const [form] = Form.useForm();
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    const roleParam = searchParams.get('role');

    if (roleParam) {
      try {
        const decodedRole = atob(roleParam);
        const parsedRole =
          decodedRole.startsWith('{') || decodedRole.startsWith('[')
            ? JSON.parse(decodedRole)
            : decodedRole;
        setRole(parsedRole);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to decode role from URL:', error);
      }
    }
  }, []);

  const onFinish = async values => {
    try {
      setLoading(true);
      await onHandleRegistration(values, searchParams.get('token'), role);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('error: ', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Checkbox: {
            colorBgContainer: '#71767C',
            colorBorder: '#71767C',
          },
        },
      }}
    >
      <LoginFormLayout
        onFinish={onFinish}
        title={
          role === 'admin'
            ? 'Complete your account set up'
            : 'Create a new password'
        }
        form={form}
        showBackButton={false}
      >
        {role === 'admin' && (
          <>
            <CustomFormInput
              label="First name"
              placeholder="John"
              name="first_name"
              rules={[
                {
                  required: true,
                  message: 'Please enter First name',
                },
              ]}
            />
            <CustomFormInput
              label="Last name"
              placeholder="Doe"
              name="last_name"
              rules={[
                {
                  required: true,
                  message: 'Please enter Last name',
                },
              ]}
            />
            <CustomFormInput
              label="Phone number"
              placeholder="XXXXXXXXXX"
              name="phone_number"
              rules={[
                {
                  required: true,
                  message: 'Please enter Phone number',
                },
                {
                  pattern: /^[6-9]\d{9}$/,
                  message: 'Please enter a valid 10-digit Indian Phone number',
                },
              ]}
            />
          </>
        )}
        <CreateNewPassword form={form} role={role} />
        <Form.Item
          name="check_status"
          valuePropName="checked"
          rules={[
            {
              required: true,
              message:
                'You must accept the Terms & Conditions and Data Privacy Policy to proceed.',
            },
          ]}
        >
          <Flex gap={8} align="flex-start" justify="flex-start">
            <Checkbox onChange={e => setIsChecked(e.target.checked)} />
            <Text>
              By creating an account, you confirm that you have read and agree
              to our{' '}
              <a
                style={{ color: '#007BC0' }}
                href="/documents/ridebuddy-tnc.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="list-item"
                aria-label="Terms & Conditions PDF (opens in new tab)"
              >
                <Text strong style={{ color: '#007BC0' }}>
                  Terms & Conditions
                </Text>
              </a>{' '}
              and{' '}
              <a
                href="/documents/ridebuddy-dpn.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="list-item"
                aria-label="Data privacy PDF (opens in new tab)"
              >
                <Text strong style={{ color: '#007BC0' }}>
                  Data Privacy Policy
                </Text>
              </a>
            </Text>
          </Flex>
        </Form.Item>
        <Form.Item style={{ paddingTop: 24 }}>
          <Button
            type="primary"
            htmlType="submit"
            block
            loading={loading}
            disabled={!isChecked}
          >
            Save and continue
          </Button>
        </Form.Item>
      </LoginFormLayout>
    </ConfigProvider>
  );
};

RegistrationForm.propTypes = {
  onHandleRegistration: PropTypes.func.isRequired,
};
export default RegistrationForm;
